import { render, staticRenderFns } from "./AddCustomFieldForm.vue?vue&type=template&id=ceab769e&scoped=true"
import script from "./AddCustomFieldForm.vue?vue&type=script&lang=js"
export * from "./AddCustomFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceab769e",
  null
  
)

export default component.exports